import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["typography", "url", "openInNewTab", "variant", "size", "buttonColor", "borderColor", "hoverColor", "hoverBorderColor", "activeColor", "activeBorderColor"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { Button } from '@miro-site/core';
import Text from './Text';
import { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";

var SuperButton = function SuperButton(_ref) {
  var typography = _ref.typography,
      url = _ref.url,
      _ref$openInNewTab = _ref.openInNewTab,
      openInNewTab = _ref$openInNewTab === void 0 ? false : _ref$openInNewTab,
      variant = _ref.variant,
      size = _ref.size,
      buttonColor = _ref.buttonColor,
      borderColor = _ref.borderColor,
      hoverColor = _ref.hoverColor,
      hoverBorderColor = _ref.hoverBorderColor,
      activeColor = _ref.activeColor,
      activeBorderColor = _ref.activeBorderColor,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var colors = theme.colors;
  var styles = {
    background: buttonColor && colors[buttonColor] || buttonColor,
    borderColor: borderColor,
    ':hover': {
      background: hoverColor && colors[hoverColor] || hoverColor,
      borderColor: hoverBorderColor && colors[hoverBorderColor] || hoverBorderColor
    },
    ':active': {
      background: activeColor && colors[activeColor] || activeColor,
      borderColor: activeBorderColor && colors[activeBorderColor] || activeBorderColor
    }
  };
  return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
    $buttonType: variant,
    $size: size,
    href: url,
    target: openInNewTab ? '_blank' : '_self',
    $styles: _objectSpread({}, styles)
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(Text, _objectSpread({
      as: "span"
    }, typography))
  }));
};

export default SuperButton;